/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'seg-update-page';
const prefix = `${moduleName}.${componentName}`;

export const seGroupsLabel = `${prefix}.seGroupsLabel`;
export const updateSuccessfulLabel = `${prefix}.updateSuccessfulLabel`;
export const updateFailedLabel = `${prefix}.updateFailedLabel`;
export const inProgressLabel = `${prefix}.inProgressLabel`;
export const viewTranscriptLabel = `${prefix}.viewTranscriptLabel`;
export const updateLabel = `${prefix}.updateLabel`;
export const patchLabel = `${prefix}.patchLabel`;

export const ENGLISH = {
    [seGroupsLabel]: 'Service Engine Groups ({0})',
    [updateSuccessfulLabel]: 'Update Successful',
    [updateFailedLabel]: 'Update Failed',
    [inProgressLabel]: 'In Progress',
    [viewTranscriptLabel]: 'View Transcript',
    [updateLabel]: 'Update',
    [patchLabel]: 'Patch',
};
